import { Link as RouterLink } from "react-router-dom";
import { cn } from "~/lib/utils";

interface LinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
}

function isExternal(href: string): boolean {
  return href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//");
}

export function Link({ href, className, children, ...props }: LinkProps) {
  const styles = cn("text-primary underline underline-offset-2 hover:text-foreground transition-colors", className);

  if (isExternal(href)) {
    return (
      <a href={href} className={styles} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={href} className={styles} {...props}>
      {children}
    </RouterLink>
  );
}
